import { Controller } from "@hotwired/stimulus"
import Marquee3k from "marquee3000"

// Marquee3k clones content until parent is filled. If content width is 0
// (images not yet loaded, fonts not yet swapped, etc.) the clone loop can
// approach infinity and lock up the main thread for ~minutes on mobile
// Safari. Wait until all <img> children are loaded before initializing.
function waitForImages(root) {
  const imgs = Array.from(root.querySelectorAll('img'))
  if (!imgs.length) return Promise.resolve()
  return Promise.all(imgs.map(img => {
    if (img.complete && img.naturalWidth > 0) return Promise.resolve()
    return new Promise(resolve => {
      const done = () => resolve()
      img.addEventListener('load', done, { once: true })
      img.addEventListener('error', done, { once: true })
      // Safety timeout — never wait more than 2s for any single image
      setTimeout(done, 2000)
    })
  }))
}

export default class extends Controller {
  connect() {
    waitForImages(this.element).then(() => {
      // Double-check content has non-zero width before letting Marquee3k
      // clone. If still zero, skip init entirely — better no scrolling
      // logos than a frozen page.
      const target = this.element.querySelector('.marquee3k')
      if (!target || !target.children.length) return
      const firstChild = target.children[0]
      if (!firstChild.offsetWidth) return
      Marquee3k.init()
    })
  }
}
